<!--table 编辑 -->
<template>
  <div class="custom_table_template2">
    <el-form ref="form" label-width="120px" inline>
      <el-form-item label="患者姓名">
        <el-input v-model="Name" placeholder="请输入患者姓名"></el-input>
      </el-form-item>
      <el-form-item label="患者身份证号">
        <el-input v-model="card" placeholder="请输入患者身份证号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-card>
      <el-table :data="listData" style="width: 100%" v-loading="loading" border>
        <el-table-column prop="commonPatName" label="姓名" min-width="80">
        </el-table-column>
        <el-table-column prop="deptName" label="科室" min-width="120">
        </el-table-column>
        <el-table-column
          prop="commonPatSex"
          label="性别"
          :formatter="formatterisBind"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="commonPatIdcard"
          label="身份证号"
          min-width="150"
        >
        </el-table-column>
        <el-table-column prop="diagnose" label="诊断" min-width="150">
        </el-table-column>
        <!-- <el-table-column
          prop="treatmentOptions"
          label="治疗意见"
          min-width="150"
        >
        </el-table-column> -->

        <el-table-column prop="visitTime" label="就诊时间" min-width="150">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <!-- <el-button
              type="success "
              size="mini"
              @click="edit(listData[scope.$index].id)"
              >编辑
            </el-button> -->
            <el-button
              type="primary"
              size="small"
              v-if="listData[scope.$index].isSign == '0'"
              @click="edit(listData[scope.$index])"
              >编辑
            </el-button>
            <el-button
              type="danger "
              size="mini"
              v-if="listData[scope.$index].isSign == '0'"
              @click="details(listData[scope.$index].id)"
              >删除
            </el-button>
            <el-button
              @click.prevent="autograph(scope.row.id)"
              v-if="listData[scope.$index].isSign == '0'"
              type="success"
              size="small"
              >签名
            </el-button>
            <el-button
              v-if="listData[scope.$index].docSignPdfAfter"
              type="primary"
              size="mini"
              @click="seePDF(listData[scope.$index].docSignPdfAfter)"
              >电子病历
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
import { MessageBox, Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      page: PAGE,
      listData: [],
      Name: "",
      card: "",
      loading: false,
    };
  },
  created: function () {},
  mounted() {
    this.loadDate();
  },
  methods: {
    async determine(id) {
      let that = this;
      this.$confirm("签名之后处方不可编辑删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let options = {
            token: localStorage.getItem("token"),
            orderId: id,
          };
          let res = await this.$http(
            "smarthos.recipe.order.open.doc.sign",
            options
          );
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "签名成功",
              type: "success",
            });
            that.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消签名",
          });
        });
    },
    async signature(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        hosId:'1100000001',
        userBookCaseHistoryId: id,
      };
      let res = await this.$http(
        "smarthos.user.book.case.history.doc.sign",
        options
      );
      if (res.code == 0) {
        Message({
          showClose: true,
          message: "签名成功",
          type: "success",
        });
        that.loadDate();
      }
    },
    async confirm(value, id) {
      if (value.value == null) {
        Message({
          showClose: true,
          message: "请输入短信验证码",
          type: "error",
        });
        return;
      }
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: id,
        businessType: "WRITE_CASE_HISTORY",
        verificationCode: value.value,
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code.check",
        options
      );
      if (res.code == 0) {
        that.signature(id);
      }
    },
    async VerificationCode(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: id,
        businessType: "WRITE_CASE_HISTORY",
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code",
        options
      );
      if (res.code == 0) {
        MessageBox.prompt("请输入短信验证码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async (inputValue) => {
            that.confirm(inputValue, id);
          })
          .catch(() => {
            return;
          });
      }
    },
    shortMessage(id) {
      let that = this;
      that
        .$confirm("即将给您本人手机号发送短信验证是否本人", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          that.VerificationCode(id);
        })
        .catch(() => {});
    },
    async autograph(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        key: "RECIPE_SEND_MEG_CODE_SWITCH",
      };
      let res = await this.$http("smarthos.system.param.key", options);
      if (res.code == 0) {
        if (res.obj.paramValue == "0") {
          that.determine(id);
        } else if (res.obj.paramValue == "1") {
          that.shortMessage(id);
        }
      }
    },
    edit(obj) {
      window.sessionStorage.setItem("editMedicalRecord", JSON.stringify(obj));
      this.$router.push({ path: "editMedicalRecord" });
    },
    search() {
      this.loadDate();
    },
    search2() {
      console.log("====>");
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.loadDate();
    },
    details(id) {
      let _this = this;
      _this
        .$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          axiosUtil(
            {
              service: "smarthos.user.book.case.history.delete",
              hosId: "1100000001",
              userBookCaseHistoryId: id,
              token: localStorage.getItem("token"),
            },
            ({ code, obj, msg }) => {
              if (code == "0") {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                _this.loadDate();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    seePDF(url) {
      window.open(url);
    },
    formatterisBind(row, column, code) {
      if (row.commonPatSex == "F") {
        return "女";
      } else {
        return "男";
      }
    },
    loadDate() {
      this.loading = true;
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.user.book.case.history.list",
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          token: localStorage.getItem("token"),
          pageNum: PAGE.pageNum,
          pageSize: PAGE.pageSize,
          commonPatName: _this.Name,
          commonPatIdcard: _this.card,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.loading = false;
            PAGE.total = obj.amout;
            _this.listData = obj.userBookCaseHistoryList;
          }
        }
      );
    },
    //远程加载数据
    loadAllRemote() {
      // debugger;
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.drugs.online.diagnosis.query",
          pageNum: _this.pageNum,
          pageSize: _this.pageSize,
          qKey: _this.state1,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            obj.list.map((item) => {
              item.value = item.dicName;
              return item;
            });
            _this.restaurants = obj.list;
          }
        }
      );
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleAdd(index, row) {
      this.diagnosis.push({});
    },
    handleDelete(index, row) {
      if (index > 0) {
        this.diagnosis.splice(index, 1);
      }
    },
  },
};
</script>
<style lang="scss">
.custom_table_template2 {
  width: 100%;
  height: 100%;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.patientLeft {
  width: 50%;
  height: 100%;
  float: left;
}
.drugsCenter {
  width: 50%;
  height: 100%;
  float: right;
}
.pagination-wrapper {
  padding: 20px 0;
}
</style>
